import bannerService from "../services/banner.service";
import { toogleErrorMessage, toogleSuccessMessage } from "./alertMessage";
import { BANNER_BYID_LIST, BANNER_LIST, BANNER_LIST_LOADER, PROMOTIONAL_BANNER_LIST, PROMOTIONAL_BANNER_LIST_LOADER } from "./type";

export const bannerDetails = (search, page, limit,type) => (dispatch) => {
  dispatch({ type: BANNER_LIST_LOADER, payload: true });
  return bannerService.bannerList(search, page, limit,type).then((resp) => {
    if (resp.status === 200) {
      dispatch({ type: BANNER_LIST, payload: resp.data });
    } else {
      dispatch({ type: BANNER_LIST_LOADER, payload: null });
    }
    return resp;
  });
};

export const promotionalBannerDetails = (search, page, limit) => (dispatch) => {
  dispatch({ type: PROMOTIONAL_BANNER_LIST_LOADER, payload: true });
  return bannerService.promotionalbannerList(search, page, limit).then((resp) => {
    if (resp.status === 200) {
      dispatch({ type: PROMOTIONAL_BANNER_LIST, payload: resp.data });
    } else {
      dispatch({ type: PROMOTIONAL_BANNER_LIST_LOADER, payload: null });
    }
    return resp;
  });
};

export const bannerListDeleteAction = (id) => async (dispatch) => {
  return await bannerService.bannerListDelete(id).then((resp) => {
    if (resp.status === 200) {
      dispatch(toogleSuccessMessage("Banner deleted successfully"));
    } else {
      dispatch(
        toogleErrorMessage(
          resp.response.data.message || "Something wen't wrong"
        )
      );
    }
    return resp;
  });
};

export const bannerAddAction = (payload) => async (dispatch) => {
  return await bannerService.bannerAdd(payload).then((resp) => {
    if (resp.status === 200) {
      dispatch(toogleSuccessMessage("Banner add successfully"));
    } else {
      dispatch(
        toogleErrorMessage(
          resp.response.data.message || "Something wen't wrong"
        )
      );
    }
    return resp;
  });
};

export const bannerByIdAction = (id) => (dispatch) => {
  return bannerService.getBannerById(id).then((resp) => {
    if (resp.status === 200) {
      dispatch({ type: BANNER_BYID_LIST, payload: resp.data });
    }
    return resp;
  });
};

export const editBannerAction = (id, payload) => async (dispatch) => {
  return await bannerService.editBanner(id, payload).then((resp) => {
    if (resp.status === 200) {
      dispatch(toogleSuccessMessage("Banner updated successfully"));
    } else {
      dispatch(
        toogleErrorMessage(
          resp.response.data.message || "Something wen't wrong"
        )
      );
    }
    return resp;
  });
};
